import api from './api';

export const packageService = {
  getPackages: async (params = {}) => {
    const response = await api.get('/packages', { params });
    return response.data;
  },

  getPackageById: async (id) => {
    const response = await api.get(`/packages/${id}`);
    return response.data;
  },

  createPackage: async (data) => {
    const response = await api.post('/packages', data);
    return response.data;
  },

  updatePackage: async (id, data) => {
    const response = await api.put(`/packages/${id}`, data);
    return response.data;
  },

  updatePackageStatus: async (id, isActive) => {
    const response = await api.patch(`/packages/${id}/status`, { isActive });
    return response.data;
  },

  getPackageComponents: async (id) => {
    const response = await api.get(`/packages/${id}/components`);
    return response.data;
  },

  addPackageComponent: async (id, componentData) => {
    const response = await api.post(`/packages/${id}/components`, componentData);
    return response.data;
  },

  removePackageComponent: async (componentId, remarks = null) => {
    const response = await api.delete(`/packages/components/${componentId}`, { data: { remarks } });
    return response.data;
  },

  getResolvedTests: async (id) => {
    const response = await api.get(`/packages/${id}/resolved-tests`);
    return response.data;
  }
};

export default packageService;
